"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ZipBuilder = void 0;
var JSZip = require("jszip");
var constants_1 = require("../utils/constants");
var ZipBuilder = (function () {
    function ZipBuilder() {
        this.zip = new JSZip();
        this.folders = {};
    }
    ZipBuilder.prototype.addFile = function (filePath, writer) {
        this.zip.file(filePath, '<?xml version="1.0" encoding="utf-8"?>\n' + writer.convertToString(), { createFolders: true });
    };
    ZipBuilder.prototype.addBase64 = function (filePath, base64) {
        this.zip.file(filePath, base64, { createFolders: true, base64: true });
    };
    ZipBuilder.prototype.generateBlob = function (callback) {
        this.zip
            .generateAsync({
            type: 'blob',
            mimeType: constants_1.ContentType.document,
            compression: 'DEFLATE',
            compressionOptions: {
                level: 1,
            },
        })
            .then(callback);
    };
    ZipBuilder.prototype.generateBase64 = function (callback) {
        this.zip
            .generateAsync({
            type: 'base64',
            compression: 'DEFLATE',
            compressionOptions: {
                level: 1,
            },
        })
            .then(callback);
    };
    return ZipBuilder;
}());
exports.ZipBuilder = ZipBuilder;
